import React from 'react';
import Button from '../forms/Button';

interface ErrorDisplayProps {
  title?: string;
  message?: string;
  subMessage?: string;
  onRetry?: () => void;
  onContactSupport?: () => void;
  showRetryButton?: boolean;
  showContactSupportButton?: boolean;
  minHeight?: string;
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  title = "We couldn't load your data",
  message = 'Something went wrong while loading your data.',
  subMessage = 'Please try again or contact support.',
  onRetry,
  onContactSupport,
  showRetryButton = true,
  showContactSupportButton = true,
  minHeight = 'calc(100vh - 200px)'
}) => {
  const defaultContactSupport = () => {
    window.location.href = 'mailto:support@authentik8.com?subject=Technical Support Request&body=I need help with an error on the platform.';
  };

  return (
    <div
      className="flex items-center justify-center"
      style={{ minHeight }}>
      <div className="text-center max-w-md">
        <h2 className="text-[20px] font-semibold text-gray-900 mb-4">
          {title}
        </h2>
        <p className="text-gray-500 mb-2">
          {message}
        </p>
        <p className="text-gray-500 mb-8">
          {subMessage}
        </p>
        <div className="flex gap-4 justify-center">
          {showRetryButton && onRetry && (
            <Button
              className="bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 px-4 py-2"
              onClick={onRetry}>
              Retry
            </Button>
          )}
          {showContactSupportButton && (
            <Button
              className="bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 px-4 py-2"
              onClick={onContactSupport || defaultContactSupport}>
              Contact support
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorDisplay;